import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddUserComponent } from '../../modals/add-user/add-user.component';
import { FakeAddUserComponent } from '../../modals/fake-add-user/fake-add-user.component';
import { DataService } from '../../../services/data.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { InfoModalComponent } from '../../modals/info-modal/info-modal.component';
import { ConfirmSentComponent } from '../../modals/confirm-sent/confirm-sent.component';
import { from, of, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { browser } from 'protractor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {

  public data = [];
  public filteredData = [];
  public pageSize = 5;
  public page = 1;
  public searchStr = '';
  public isLoading = false;


  constructor(
    private modalService: NgbModal,
    private service: DataService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.fetchData();

  }

  filter(event) {
    const filterValue = event.target.value;
    this.filteredData = this.data.filter(function (itm) {
      if (!itm.name) return;
      return itm.name[0].toLowerCase().includes(filterValue.toLowerCase());
    });
  }

  openAddUser() {
    const options2modal: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      size: 'lg',
      centered: true
    };
    this.modalService.open(AddUserComponent, options2modal).result.then(email => {
      this.isLoading = true;
      if (email !== 'file_upload') {
        this.service.addUser(email).pipe(
          switchMap(() => {
            return this.service.inviteUser(email);
          })
        ).
          subscribe(() => {
            this.fetchData()
          }, error => {
            this.isLoading = false;
            const infoDlg = this.modalService.open(InfoModalComponent);
            infoDlg.componentInstance.data = {
              text: error.error,
              header: 'Error'
            };
            infoDlg.result.then(ok => {
            });
          });
      }
      else {
        this.fetchData();
      }
    });
  }

  // openFakeAddUser() {
  //   const options2modal: NgbModalOptions = {
  //     backdrop: true,
  //     keyboard: false,
  //     size: 'lg',
  //     centered: true
  //   };
  //   this.modalService.open(FakeAddUserComponent, options2modal).result.then(user => {
  //     this.service.addUserWithPwd(user.email, user.password, user.passwordCheck).subscribe(() => {
  //       this.fetchData()
  //     }, error => {
  //       const infoDlg = this.modalService.open(InfoModalComponent);
  //       infoDlg.componentInstance.data = {
  //         text: error.error,
  //         header: 'Error'
  //       };
  //       infoDlg.result.then(ok => {
  //       });
  //     });
  //   });
  // }

  private fetchData() {
    this.service
      .getUsers()
      .pipe(map(response => {
        return response.map(res => {
          return {
            projectId: res.projectID.id,
            name: res.userAttributes.firstName,
            email: res.userID.id,
            type: res.userAttributes.userType && res.userAttributes.userType[0].toLowerCase(),
            date: res.lastInvitation,
            status: res.active,
            invited: res.invited
          }
        })
      }))
      .subscribe(users => {
        this.data = users;
        this.filteredData = this.data;
        this.isLoading = false;
      });
  }

  enableUser(user) {
    if (user.invited) {
      const browserLang = this.translate.currentLang;
      this.service.enableUser(user).pipe(
        switchMap(() => {
          return this.service.activateUserMail(user, browserLang);
        })
      ).
        subscribe(() => this.fetchData());
    }
    else {
      const infoDlg = this.modalService.open(InfoModalComponent);
      infoDlg.componentInstance.data = {
        text: 'This user is not invited yet',
        header: 'Info'
      };
    }
  }

  deleteUser(user) {
    const confirm = this.modalService.open(ConfirmSentComponent);
    confirm.componentInstance.data = {
      text: 'Are you sure you want to remove the selected user?',
      header: 'Remove user'
    };
    from(confirm.result).pipe(
      switchMap(ok => this.service.deleteUser(user.email)),
      switchMap(response => {
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'The user has been deleted',
          header: 'Info'
        };
        return from(infoDlg.result);
      }),
      catchError(error => {
        if (error === 'no' || !error) {
          return of(error);
        }
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: `Internal Server Error \n ${error.error.message}`,
          header: 'Error'
        };
        return throwError(infoDlg.result);
      })
    ).subscribe(answer => this.fetchData());
  }

  invite(user) {
    this.service.inviteUser(user.email)
      .pipe(
        switchMap(project => {
          const infoDlg = this.modalService.open(InfoModalComponent);
          infoDlg.componentInstance.data = {
            text: 'Invitation sent',
            header: 'Info'
          };
          return from(infoDlg.result);
        })
      )
      .subscribe(response => this.fetchData());
  }
}
